import React from "react";

export const TriangleUp = ({ ...props }) => (
  <svg
    width="23"
    height="19"
    viewBox="0 0 23 19"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path d="M11.5 0L22.3253 18.75H0.674683L11.5 0Z" />
  </svg>
);
